import * as React from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackActivity } from "@/utils/trackActivity";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const MediaPlannerView = ({ onBack }) => {
  const iframeRef = React.useRef(null);

  React.useEffect(() => {
    trackActivity("view_module", "media_planner");
  }, []);

  React.useEffect(() => {
    const handleLoad = () => {
      try {
        if (iframeRef.current && iframeRef.current.contentWindow) {
          iframeRef.current.contentWindow.DATAHUB_API_URL = BACKEND_URL;
        }
      } catch (e) {
        // Same-origin, should work
      }
    };

    const iframe = iframeRef.current;
    if (iframe) {
      iframe.addEventListener("load", handleLoad);
      return () => iframe.removeEventListener("load", handleLoad);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <header className="border-b bg-white sticky top-0 z-10 flex-shrink-0">
        <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-3">
          <Button variant="ghost" size="sm" onClick={onBack} data-testid="media-planner-back">
            <ArrowLeft className="h-4 w-4 mr-1" />
            Volver
          </Button>
          <div className="h-5 w-px bg-slate-200" />
          <span className="text-sm font-medium text-slate-700">Media Planner Digital</span>
        </div>
      </header>
      <iframe
        ref={iframeRef}
        src="/media-planner.html"
        className="flex-1 w-full border-0"
        style={{ minHeight: "calc(100vh - 49px)" }}
        title="Media Planner Digital"
      />
    </div>
  );
};
